import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import "./PhoneNumberInput.scss";

const PHONE_NUMBER_VALIDATIONS = {
  "1": { country: "United States/Canada", minLength: 10, maxLength: 10 },
  "51": { country: "Peru", minLength: 9, maxLength: 9 },
  "55": { country: "Brazil", minLength: 10, maxLength: 11 },
  "54": { country: "Argentina", minLength: 10, maxLength: 10 },
  "57": { country: "Colombia", minLength: 10, maxLength: 10 },
  "56": { country: "Chile", minLength: 9, maxLength: 9 },
  "593": { country: "Ecuador", minLength: 9, maxLength: 9 },
  "58": { country: "Venezuela", minLength: 10, maxLength: 10 },
  "44": { country: "United Kingdom", minLength: 10, maxLength: 10 },
  "49": { country: "Germany", minLength: 10, maxLength: 11 },
  "33": { country: "France", minLength: 9, maxLength: 9 },
  "39": { country: "Italy", minLength: 9, maxLength: 10 },
  "34": { country: "Spain", minLength: 9, maxLength: 9 },
  "31": { country: "Netherlands", minLength: 9, maxLength: 9 },
  "41": { country: "Switzerland", minLength: 9, maxLength: 9 },
  "46": { country: "Sweden", minLength: 9, maxLength: 9 },
  "48": { country: "Poland", minLength: 9, maxLength: 9 },
  "380": { country: "Ukraine", minLength: 9, maxLength: 9 },
  "91": { country: "India", minLength: 10, maxLength: 10 },
  "86": { country: "China", minLength: 11, maxLength: 11 },
  "81": { country: "Japan", minLength: 10, maxLength: 10 },
  "82": { country: "South Korea", minLength: 10, maxLength: 11 },
  "92": { country: "Pakistan", minLength: 10, maxLength: 10 },
  "62": { country: "Indonesia", minLength: 10, maxLength: 12 },
  "65": { country: "Singapore", minLength: 8, maxLength: 8 },
  "66": { country: "Thailand", minLength: 9, maxLength: 9 },
  "84": { country: "Vietnam", minLength: 9, maxLength: 10 },
  "60": { country: "Malaysia", minLength: 9, maxLength: 10 },
  "63": { country: "Philippines", minLength: 10, maxLength: 10 },
  "971": { country: "United Arab Emirates", minLength: 9, maxLength: 9 },
  "966": { country: "Saudi Arabia", minLength: 9, maxLength: 9 },
  "972": { country: "Israel", minLength: 9, maxLength: 9 },
  "20": { country: "Egypt", minLength: 10, maxLength: 10 },
  "90": { country: "Turkey", minLength: 10, maxLength: 10 },
  "27": { country: "South Africa", minLength: 9, maxLength: 9 },
  "234": { country: "Nigeria", minLength: 10, maxLength: 10 },
  "254": { country: "Kenya", minLength: 9, maxLength: 9 },
  "212": { country: "Morocco", minLength: 9, maxLength: 9 },
  "61": { country: "Australia", minLength: 9, maxLength: 9 },
  "64": { country: "New Zealand", minLength: 9, maxLength: 9 },
};
const DEFAULT_VALIDATION = { minLength: 5, maxLength: 15 };

const PhoneNumberInput = ({
  value,
  onChange,
  label = "",
  disabled = false,
  name = "",
  placeholder = "",
}: any) => {
  // Validate phone number based on country code
  const validatePhoneNumber = (phoneNumber: string, countryCode: string) => {
    const cleanNumber = extractPhoneNumber(phoneNumber, countryCode);
    const validation =
      PHONE_NUMBER_VALIDATIONS[
        countryCode as keyof typeof PHONE_NUMBER_VALIDATIONS
      ] || DEFAULT_VALIDATION;

    if (
      cleanNumber.length < validation.minLength ||
      cleanNumber.length > validation.maxLength
    ) {
      return {
        isValid: false,
        message: `Phone number for ${
          validation.country || "this country"
        } must be ${
          validation.minLength === validation.maxLength
            ? `${validation.minLength} digits`
            : `between ${validation.minLength} and ${validation.maxLength} digits`
        }`,
      };
    }

    return { isValid: true, message: "" };
  };

  const extractPhoneNumber = (phone: string, countryCode: string) => {
    const cleanedPhone = phone.replace(/\D/g, "");
    if (cleanedPhone.startsWith(countryCode)) {
      return cleanedPhone.slice(countryCode.length);
    }
    return cleanedPhone;
  };

  return (
    <>
      <label className="block mb-1">{label}</label>
      <PhoneInput
        value={value.phone}
        disabled={disabled}
        placeholder={placeholder}
        className="react-country-phone-number-input-box"
        inputClassName="block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white !dark:border-neutral-700 !dark:focus:ring-primary-6000 !dark:focus:ring-opacity-25 !dark:bg-neutral-900 !h-11 px-4 !py-3 text-sm font-normal !rounded-2xl"
        onChange={(value, meta) => {
          const country_code = meta?.country?.dialCode || "";
          const cleanNumber = extractPhoneNumber(value, country_code);
          const validation = validatePhoneNumber(value, country_code);

          onChange({
            phone: value,
            country_code,
            valid_phone_number: cleanNumber,
            isValid: validation.isValid,
            validationMessage: validation.message,
          });
        }}
      />
    </>
  );
};

export default PhoneNumberInput;
